module.exports = __webpack_public_path__ + "static/media/WB.a80dca97.svg";